/**
 * The regexs based on data by RDW
 * http://www.rdw.nl/Particulier/Paginas/Uitleg-over-de-cijfers-en-letters-op-de-kentekenplaat.aspx?path=Portal/Particulier/De%20kentekenplaat/Het%20kenteken%20op%20de%20plaat
 */
const licensePlateRegexs = [
    /^([A-Z]{2})-?([0-9]{2})-?([0-9]{2})$/ /* 1951 XX-99-99 */,
    /^([0-9]{2})-?([0-9]{2})-?([A-Z]{2})$/ /* 1965 99-99-XX */,
    /^([0-9]{2})-?([A-Z]{2})-?([0-9]{2})$/ /* 1973 99-XX-99 */,
    /^([A-Z]{2})-?([0-9]{2})-?([A-Z]{2})$/ /* 1978 XX-99-XX */,
    /^([A-Z]{2})-?([A-Z]{2})-?([0-9]{2})$/ /* 1991 XX-XX-99 */,
    /^([0-9]{2})-?([A-Z]{2})-?([A-Z]{2})$/ /* 1999 99-XX-XX */,
    /^([0-9]{2})-?([A-Z]{3})-?([0-9]{1})$/ /* 2005 99-XXX-9 */,
    /^([0-9]{1})-?([A-Z]{3})-?([0-9]{2})$/ /* 2009 9-XXX-99 */,
    /^([A-Z]{2})-?([0-9]{3})-?([A-Z]{1})$/ /* 2006 XX-999-X */,
    /^([A-Z]{1})-?([0-9]{3})-?([A-Z]{2})$/ /* 2008 X-999-XX */,
    /^([A-Z]{3})-?([0-9]{2})-?([A-Z]{1})$/ /* 2015 XXX-99-X */,
];
/**
 * This will only validate if the provided licenseplate was valid
 * @param licensePlate A string representing the licenceplate
 * @return		         True or false depending on a valid licenseplate
 */
export const validateLicensePlate = (licensePlate) => licensePlateRegexs.some((pattern) => pattern.test(licensePlate));
/**
 * This will validate if the provided license plate is valid and will return a nicely formatted string seperated by a dash if it is
 * @param licensePlate A string representing the licenceplate
 * @return		         Either false if the provided string wasn't a valid license plate or a string representing a formatted licenseplate
 */
export const formatLicensePlate = (licensePlate) => {
    let formattedLicensePlate = licensePlate.toUpperCase().replace(/[^A-Z0-9\-\\s]/g, '');
    const validLicensePlate = licensePlateRegexs.some((pattern) => {
        if (pattern.test(formattedLicensePlate)) {
            formattedLicensePlate = formattedLicensePlate.replace(pattern, '$1-$2-$3');
            return true;
        }
        return false;
    });
    return validLicensePlate && formattedLicensePlate;
};
export default formatLicensePlate;
